import { createSlice } from '@reduxjs/toolkit';


const blogSlice = createSlice({
    name: 'blog',
    initialState: {
        blog: [
            {
                id: 1,
                foto: 'Trend1.png',
                category: 'Kitchen Design',
                title: 'Residential Interior Designer In New York, USA',
                date: 'November 06, 2023',
            },
            {
                id: 2,
                foto: 'Trend2.png',
                category: 'Living Room',
                title: 'How To Choose The Best Wall Art & Decor House?',
                date: 'November 06, 2023',
                may: 'May',
            },
            {
                id: 3,
                foto: 'Trend3.png',
                category: 'Minimalist Interior',
                title: 'Tips To Increase The Interior Value Of Your House',
                date: 'November 06, 2023',
            },
            {
                id: 4,
                foto: 'Trend4.png',
                category: 'Kitchen Design',
                title: 'Best Solution For Any Office & Business Interior',
                date: 'November 06, 2023',
            },
            {
                id: 5,
                foto: 'Trend5.png',
                category: 'Living Room',
                title: 'Get Solution For Building Construction Work',
                date: 'November 06, 2023',
            },
            {
                id: 6,
                foto: 'Trend6.png',
                category: 'Minimalist Interior',
                title: 'Attain The Best Finish For The Kitchen Cabinets',
                date: 'November 06, 2023',
                recent: '',
            },
        ],
        recent: [
            {
                id: 1,
                recent: 1,
                foto: 'Trend6.png',
                category: 'Minimalist Interior',
                title: 'Attain The Best Finish For The Kitchen Cabinets',
                date: 'November 06, 2023',
                recent: '1',
            },
            {
                id: 2,
                recent: 2,
                foto: 'Trend2.png',
                category: 'Living Room',
                title: 'How To Choose The Best Wall Art & Decor House?',
                date: 'November 06, 2023',
            },
        ]
    }
})
export default blogSlice.reducer;